import type { SVGProps } from "react";

export const Zoom = (props: SVGProps<SVGSVGElement>) => (
  <svg
    height="1em"
    viewBox="0 0 48 48"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>Zoom</title>{" "}
    <defs>
      {" "}
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="zoom-gradient"
        x1="11.3597"
        x2="36.6403"
        y1="45.89364"
        y2="2.10636"
      >
        {" "}
        <stop offset="0" stopColor="#0845bf" />{" "}
        <stop offset=".6" stopColor="#0b5cff" />{" "}
        <stop offset="1" stopColor="#4f90ee" />{" "}
      </linearGradient>{" "}
    </defs>{" "}
    <g>
      {" "}
      <path
        d="M48,24c0,2.56649-.20631,5.08306-.60043,7.53687-1.30472,8.12336-7.73942,14.55801-15.86279,15.8627-2.45387.39412-4.97047.60043-7.53678.60043s-5.08291-.20631-7.53678-.60043c-8.12337-1.30469-14.55806-7.73934-15.86279-15.8627C.20631,29.08306,0,26.56649,0,24s.20631-5.08306.60043-7.53687C1.90515,8.33977,8.33985,1.90512,16.46322.60043,18.91709.20631,21.43368,0,24,0s5.08291.20631,7.53678.60043c8.12337,1.30469,14.55806,7.73934,15.86279,15.8627.39411,2.45381.60043,4.97038.60043,7.53687Z"
        fill="url(#zoom-gradient)"
      />{" "}
      <path
        d="m20.407,31.33266h-11.8779c-.83337,0-1.57795-.49753-1.89686-1.26746-.31891-.76993-.14418-1.64827.44512-2.23746l8.22737-8.22733h-5.89671c-1.61989,0-2.93306-1.31317-2.93306-2.93306h10.95403c.8333,0,1.57785.49739,1.89679,1.26732.31898.76993.14436,1.64813-.44486,2.23761l-8.2274,8.22733h6.82044c1.61989,0,2.93306,1.31317,2.93306,2.93306Zm21.11806-9.16583c0-3.15376-2.56575-5.71948-5.71948-5.71948-1.68694,0-3.20517.73455-4.25294,1.90012-1.04777-1.16556-2.566-1.90012-4.25294-1.90012-3.15372,0-5.71948,2.56572-5.71948,5.71948v9.16583c1.61988,0,2.93306-1.31318,2.93306-2.93306v-6.23276c0-1.53642,1.24999-2.78641,2.78641-2.78641s2.78641,1.24999,2.78641,2.78641v6.23276c0,1.61989,1.31318,2.93306,2.93306,2.93306v-9.16583c0-1.53642,1.24999-2.78641,2.78641-2.78641s2.78641,1.24999,2.78641,2.78641v6.23276c0,1.61989,1.31318,2.93306,2.93306,2.93306v-9.16583Z"
        fill="#fff"
      />{" "}
    </g>
  </svg>
);

export default Zoom;
